/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useCallback } from 'preact/hooks';
import { usePress } from '../hooks/UNSAFE_usePress';
import { DropdownArrowIcon } from '../PRIVATE_ThemedIcons/DropdownArrowIcon';
import { classNames } from '../utils/UNSAFE_classNames';
import { dropdownStyles } from './themes/dropdownStyles.css';
import { useComponentTheme } from '#hooks/UNSAFE_useComponentTheme';
import { ButtonLayoutRedwoodTheme } from '#UNSAFE_ButtonLayout/themes/redwood/ButtonLayoutTheme';

type Props = {
  isDisabled?: boolean;
  onClick?: () => void;
  size?: 'md' | 'sm';
};

const noop = () => {};

export function DropdownArrow({ isDisabled = false, onClick, size = 'md' }: Props) {
  const { baseTheme: buttonLayoutBaseTheme } = useComponentTheme(ButtonLayoutRedwoodTheme);
  const preventDefault = useCallback((event: Event) => {
    event.preventDefault();
  }, []);
  const { pressProps } = usePress(onClick ?? noop, { isDisabled });

  const styleClasses = classNames([
    buttonLayoutBaseTheme,
    dropdownStyles.arrow.base,
    size === 'sm' ? dropdownStyles.arrow.sizeSm : dropdownStyles.arrow.sizeMd,
    isDisabled ? dropdownStyles.arrow.disabled : dropdownStyles.arrow.enabled
  ]);

  return (
    <span
      aria-hidden="true"
      class={styleClasses}
      tabIndex={-1}
      onMouseDown={preventDefault}
      {...pressProps}>
      <DropdownArrowIcon />
    </span>
  );
}
